import buildQuery from "odata-query";
import axios, { CancelTokenSource } from 'axios';

import axiosDmsInstance from './axiosDmsInstance';
import { getApiDateMoment, getStateMomentAsString, handleApiError } from '../../common/util';
import { ITechClockingDetail } from '../../models/dms/clocking.model';
import { fetchOdataAll } from '../../common/odataUtil';
import { IWorkCategory } from '../../models/dms/technician.model';

export let getTechClockingCancelTokenSource: CancelTokenSource;

export const getTechClocking = async (techCode: string) => {
  try {
    const url = `/api/common/technician/v1/clocking/${techCode}`;
    let params = {} as any;

    // Cancelation token
    getTechClockingCancelTokenSource?.cancel(`CANCEL getTechClocking`);;
    getTechClockingCancelTokenSource = axios.CancelToken.source();

    const response = await axiosDmsInstance.get<ITechClockingDetail>(`${url}`, {
      params,
      cancelToken: getTechClockingCancelTokenSource.token,
    });

    return {
      ...response.data,
      attendanceClocking: {
        ...response.data.attendanceClocking,
        startDateTime: getStateMomentAsString(getApiDateMoment(response.data.attendanceClocking.startDateTime)),
        endDateTime: response.data.attendanceClocking.endDateTime ? getStateMomentAsString(getApiDateMoment(response.data.attendanceClocking.endDateTime)) : undefined,
      },
      labourClocking: {
        ...response.data.labourClocking,
        startDateTime: getStateMomentAsString(getApiDateMoment(response.data.labourClocking.startDateTime)),
        endDateTime: response.data.labourClocking.endDateTime ? getStateMomentAsString(getApiDateMoment(response.data.labourClocking.endDateTime)) : undefined,
      }
    } as ITechClockingDetail;
  } catch (err: any) {
    return handleApiError('getTechClocking', err);
  }
};

export const getTechWorkCategories = async (techCode: string) => {
  try {
    const url = `/api/common/technician/v1/workcategory/list`;
    const params = {};

    let filter = {
      and: []
    } as { and: any[]; };

    filter.and.push({ TechnicianCode: { eq: techCode } });

    const query = buildQuery({ filter: filter });
    const response = await fetchOdataAll<IWorkCategory>(axiosDmsInstance, `${url}/${query}`, {
      params
    });

    return response.data;
  } catch (err: any) {
    return handleApiError('getTechWorkCategories', err);
  }
};